module.exports = __webpack_public_path__ + "static/media/olefit-logo.d2b54afa.svg";